;(function () {
  angular
    .module('contrast.vulnerabilities')
    .factory('traceApiConfig', traceApiConfigFactory)

  function traceApiConfigFactory($http, UserService) {
    'ngInject'

    return {
      quickSearch: function (q) {
        return $http.get(UserService.buildAPIUrl('/traces/' + q))
      },

      getTrace: function (appId, traceUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl('/traces/' + appId + '/trace/' + traceUuid),
          { params: { expand: expandValue } }
        )
      },
      getTraceServers: function (appId, traceUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/trace/' + traceUuid + '/servers'
          ),
          { params: { expand: expandValue } }
        )
      },
      getTraceRequirements: function (appId, traceUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/trace/' + traceUuid + '/requirements'
          ),
          { params: { expand: expandValue } }
        )
      },
      getTraceRoutes: function (appId, traceUuid) {
        return $http.get(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/trace/' + traceUuid + '/routes'
          )
        )
      },
      getVulnerabilityInstanceMetadata: function (appId, traceUuid) {
        return $http.get(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/trace/' + traceUuid + '/metadata'
          )
        )
      },

      sendToBugtracker: function (appId, bugtrackerId, data) {
        return $http.post(
          UserService.buildAPIUrl(
            '/traces/' + appId + '/bugtracker/' + bugtrackerId
          ),
          data
        )
      }
    }
  }
})()
